import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataService, UserService, OperationsService, AuthenticationService, StorageService, LoansService } from '../../_services/index';
import { FormArray, ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { IMyDpOptions } from 'mydatepicker';
import { IMyDateModel, IMyInputFieldChanged, IMyCalendarViewChanged, IMyInputFocusBlur, IMyMarkedDate, IMyDate, IMySelector } from 'mydatepicker';
import { Router } from '@angular/router';
declare var swal: any;

@Component({
  selector: 'app-approvinginvestment',
  templateUrl: './approvinginvestment.component.html',
  styleUrls: ['./approvinginvestment.component.css', 'style.css', 'boot-outline-btn.css']
})
export class ApprovinginvestmentComponent implements OnInit {
  
  lender_banks = 0;
  loading = false;
  public nigerian_banks = [];
  complexForm = {
    'REQUEST_ID': '',
    'DISBURSEMENT_BANK': '',
    'SECURITY_ANSWER': ''
  };
  makingFinalPayment = false;
  payment_stage = '2';
  currentUser:any;
  @Input('disburse') loan:any;
  processDone = '0';
  amount_debited = 0;
  payment_status = true;
  banks:any;
  disbursing = false;
  @Output() paymentHasBeenProcessedFinally = new EventEmitter();
  @Output() closePaymentDialog = new EventEmitter();
  paymentHasBeenProcessed= false;
  otpError = false;
  paymentConfirmed=false;
  otpmessage = '';
  constructor(
    private router: Router,public toastr: ToastrService, private DataService: DataService, public loansService: LoansService,
    public fb: FormBuilder, public operationsService: OperationsService, public storageService: StorageService) {
    this.currentUser = this.storageService.read<any>('currentUser');
    this.operationsService.getNigerianBanks(this.currentUser.token).subscribe(nigerian_banks => this.nigerian_banks = nigerian_banks);
 
    this.complexForm.REQUEST_ID = this.loan.REQUEST_ID;
    
  }
  showSuccess(message) {
    this.toastr.success(message, 'Success!');
  }
  
  showError(message) {
    this.toastr.error(message, 'Error');
  }
  
  doPaymentConfirm(value: any): void {
    
    this.otpError = false; 
    this.makingFinalPayment = true;
    this.paymentHasBeenProcessed = false;
    this.payment_status = false;
    this.loading = true; 
    this.operationsService.doInvestmentPaymentConfirm(this.currentUser.token, value)
      .subscribe(status => {

        this.loading = false;
        if (status.status == true) {
          this.DataService.runOperationsTest.emit();
          this.paymentHasBeenProcessed = true;
          this.otpError = false;
          this.paymentConfirmed = true;
          this.payment_status = true; 
          this.DataService.refreshRequestList.emit({}); 
        } else {
          this.loading = false; 
          this.makingFinalPayment = false;
          this.paymentHasBeenProcessed = false;
          this.otpError = true;
          this.otpmessage = status.message;
          this.showError(status.message);
        }
      });
  }
   
  closeOverlay() {
    this.disbursing = false;
    this.closePaymentDialog.emit({})
  }
  closeModal() {
    this.DataService.onCancelPayment.emit(false);
    this.paymentHasBeenProcessedFinally.emit();
  }  
  ngOnInit() {  
    this.getBanks();
    this.makingFinalPayment = false;
    this.paymentHasBeenProcessed = false;
    this.otpError = false; 

  }

  rejectRequest(event) {
    this.operationsService.cancelQueuedOperation(this.currentUser.token, event)
      .subscribe(result => {

      });
  }  

  getBanks() {
    this.operationsService.getBanks(this.currentUser.token)
      .subscribe(banks => {
        this.banks = banks.banks;
        this.lender_banks = banks.count;
      });
  }
 
  showEMessage(event){
    this.showError(event.message);
  } 
}
